import { getInstrument } from "../../../../../data/instrumentManager";
import { InstrumentAmountDTOInstrumentEnum } from "../../../../../openapi-generated-client";
import "./editPieceSearchInstrumentElement.css";

interface editPieceSearchInstrumentElementProps {
    instrument: InstrumentAmountDTOInstrumentEnum;
    suffix?: string;
    onClick: () => void;
}

export default function EditPieceSearchInstrumentElement(props: editPieceSearchInstrumentElementProps) {

    const instrument = getInstrument(props.instrument);

    if(instrument == undefined) {
        return <div className="search-instrument-element">
            <a>Unknown instrument</a>
        </div>;
    }

    return <div onClick={props.onClick} className="search-instrument-element">
        {instrument.icon}
        <a>{instrument.name}{props.suffix}</a>
        <label>+ Add</label>
    </div>;
}